module.exports = __webpack_public_path__ + "945ab4197c714683a4f3e940ff951028.jpg";